export enum SavedDashboardsActions {
  Rename = 'rename',
  Delete = 'delete',
  Share = 'share',
}
